import TextEditTextAlignBlock from './TextEditTextAlignBlock'

export default TextEditTextAlignBlock
